import React from 'react';
import { Calendar, Users, Globe, Award, Clock, Check, X } from 'lucide-react';
import Button from '../../components/ui/Button';
import { useSocial } from '../../context/SocialContext';
const ThemedLunches: React.FC = () => {
  const {
    themedEvents,
    registerForThemedLunch
  } = useSocial();
  return <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1363">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#E84118] to-[#c83616] rounded-lg p-6 md:p-8 text-white mb-6 md:mb-8" data-id="element-1364">
        <h1 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4" data-id="element-1365">
          Themed Lunches
        </h1>
        <p className="text-base md:text-lg opacity-90" data-id="element-1366">
          Join industry-focused networking lunches with great conversations and
          insights from experts
        </p>
      </div>
      {/* Upcoming Events */}
      {themedEvents.length === 0 ? <div className="bg-white rounded-lg shadow-md p-8 text-center" data-id="element-1367">
          <Calendar className="mx-auto text-gray-400 mb-3" size={32} data-id="element-1368" />
          <p className="text-gray-500 mb-2" data-id="element-1369">
            No upcoming themed lunches at the moment.
          </p>
          <p className="text-sm text-gray-400" data-id="element-1370">
            Check back soon for new events!
          </p>
        </div> : <div className="space-y-6" data-id="element-1371">
          {themedEvents.map(event => <div key={event.id} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-1372">
              <div className="md:flex" data-id="element-1373">
                <div className="p-5 md:p-6 md:w-2/3" data-id="element-1374">
                  <div className="flex justify-between items-start mb-4" data-id="element-1375">
                    <h2 className="text-xl font-bold" data-id="element-1376">{event.title}</h2>
                    {event.registered && <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full flex items-center" data-id="element-1377">
                        <Check size={14} className="mr-1" data-id="element-1378" />
                        Registered
                      </span>}
                  </div>
                  <div className="space-y-3 text-gray-600" data-id="element-1379">
                    <div className="flex items-center" data-id="element-1380">
                      <Calendar size={18} className="mr-2 text-gray-500 flex-shrink-0" data-id="element-1381" />
                      <span data-id="element-1382">
                        {event.date.toLocaleDateString(undefined, {
                    weekday: 'long',
                    month: 'long',
                    day: 'numeric'
                  })}
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-1383">
                      <Clock size={18} className="mr-2 text-gray-500 flex-shrink-0" data-id="element-1384" />
                      <span data-id="element-1385">12:30 PM - 2:00 PM</span>
                    </div>
                    <div className="flex items-center" data-id="element-1386">
                      <Globe size={18} className="mr-2 text-gray-500 flex-shrink-0" data-id="element-1387" />
                      <span data-id="element-1388">{event.theme}</span>
                    </div>
                    <div className="flex items-center" data-id="element-1389">
                      <Award size={18} className="mr-2 text-gray-500 flex-shrink-0" data-id="element-1390" />
                      <span data-id="element-1391">
                        Speaker:{' '}
                        <span className="font-medium" data-id="element-1392">{event.speaker}</span>
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-1393">
                      <Users size={18} className="mr-2 text-gray-500 flex-shrink-0" data-id="element-1394" />
                      <span className={event.availableSeats < 5 ? 'text-red-600 font-medium' : ''} data-id="element-1395">
                        {event.availableSeats} seats available
                      </span>
                    </div>
                  </div>
                  <div className="mt-5 md:mt-6" data-id="element-1396">
                    <Button onClick={() => registerForThemedLunch(event.id)} disabled={event.registered || event.availableSeats === 0} variant={event.registered ? 'secondary' : 'primary'} data-id="element-1397">
                      {event.registered ? 'Registered' : event.availableSeats === 0 ? 'Fully Booked' : 'Register Now'}
                    </Button>
                  </div>
                </div>
                <div className="md:w-1/3 bg-gray-50 p-5 md:p-6 border-t md:border-t-0 md:border-l border-gray-100" data-id="element-1398">
                  <h3 className="font-medium mb-3 text-gray-900" data-id="element-1399">
                    What to expect:
                  </h3>
                  <ul className="space-y-2 text-sm text-gray-600" data-id="element-1400">
                    <li className="flex items-start" data-id="element-1401">
                      <Check size={16} className="mr-2 text-green-500 mt-0.5" data-id="element-1402" />
                      <span data-id="element-1403">Expert insights from industry leader</span>
                    </li>
                    <li className="flex items-start" data-id="element-1404">
                      <Check size={16} className="mr-2 text-green-500 mt-0.5" data-id="element-1405" />
                      <span data-id="element-1406">Networking opportunities with professionals</span>
                    </li>
                    <li className="flex items-start" data-id="element-1407">
                      <Check size={16} className="mr-2 text-green-500 mt-0.5" data-id="element-1408" />
                      <span data-id="element-1409">Q&A session with the speaker</span>
                    </li>
                    <li className="flex items-start" data-id="element-1410">
                      <Check size={16} className="mr-2 text-green-500 mt-0.5" data-id="element-1411" />
                      <span data-id="element-1412">Curated lunch menu included</span>
                    </li>
                  </ul>
                  <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-1413">
                    <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-1414">
                      Location:
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-1415">
                      Conference Room A<br data-id="element-1416" />
                      12th Floor, Tower Building
                      <br data-id="element-1417" />
                      123 Business Street
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>}
    </div>;
};
export default ThemedLunches;